// packages/shared/src/schemas/stock.ts
import { z } from 'zod'

export const StockAdjustInput = z.object({
  productId: z.string().optional(),
  variantId: z.string().optional(),
  comboId: z.string().optional(),
  adjustmentType: z.enum(['manual_adjustment', 'initial_stock']),
  quantityChange: z.number().int().refine((n) => n !== 0, 'Quantity change cannot be zero'),
  reason: z.string().min(5, 'Reason must be at least 5 characters').max(500),
}).refine(
  (d) => [d.productId, d.variantId, d.comboId].filter(Boolean).length === 1,
  { message: 'Provide exactly one of productId, variantId, or comboId' },
)

export type StockAdjustInput = z.infer<typeof StockAdjustInput>
